const topics = [
  { label: '#韩漫推荐', hot: true, count: '12.8万讨论' },
  { label: '#日漫追更', hot: true, count: '9.6万讨论' },
  { label: '#国漫崛起', hot: true, count: '8.3万讨论' },
  { label: '#秘密教学', hot: false, count: '6.5万讨论' },
  { label: '#咒术回战', hot: false, count: '5.2万讨论' },
  { label: '#下拉阅读', hot: false, count: '4.1万讨论' },
  { label: '#漫画APP推荐', hot: true, count: '3.8万讨论' },
  { label: '#斗破苍穹全彩', hot: false, count: '3.6万讨论' },
  { label: '#漫画排行榜', hot: false, count: '2.9万讨论' },
  { label: '#女神降临完结', hot: true, count: '2.7万讨论' },
  { label: '#一人之下', hot: false, count: '2.4万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">全网漫画爱好者都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#comments"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {t.label}
              <span className="text-xs opacity-70">{t.count}</span>
              {t.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}